

export const BASE_URL: string = "https://nemhanoi.tech"

